/**
 * auth service
 */
import * as api from '../../api/auth';

// 本地与服务器时间差
const TIME_DIFF_KEY = '__time_diff';
const setTimeDiff = (responseDate) => {
  const timeDiff = +new Date(responseDate) - Date.now();
  localStorage.setItem(TIME_DIFF_KEY, String(timeDiff));
};

/**
 * 获取当前时间（为了解决本地时间不准确问题）
 */
export const getDateNow = () => {
  const timeDiff = Number(localStorage.getItem(TIME_DIFF_KEY));
  return Date.now() + timeDiff;
};

/**
 * 获取Token信息
 * params: { service: string; ticket: string }
 */
export const getTokenInfo = (params) =>
  new Promise((resolve) => {
    api.getToken(params).then((res) => {
      if (+res.data.code === 0) {
        setTimeDiff(res.headers.date);
        resolve({ rs: res.data.rs });
      }
      resolve(res);
    });
  });

/**
 * 刷新token
 * @param params { rt: string }
 * @returns
 */
export const refreshTokenInfo = (params) =>
  new Promise((resolve) => {
    api.refreshToken(params).then((res) => {
      if (+res.data.code === 0) {
        setTimeDiff(res.headers.date);
        resolve({ rs: res.data.rs });
      }
      resolve(null);
    });
  });

/**
 * logout
 */
export const logout = () => api.logout();
